import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';

import createAction from './index';
import * as services from '../services/updateCaseDataForm';

export const CLEAR_CASE_DATA_FORM = createAction('CLEAR_CASE_DATA_FORM');
export const UPDATE_CASE_DATA_FORM = createAsyncAction(createAction('UPDATE_CASE_DATA_FORM'));

export const updateCaseDataForm = (formData) => async (dispatch, getState) => {
  dispatch({ type: UPDATE_CASE_DATA_FORM.pending });

  const { appointmentId } = getState().appointmentInfo.currentAppointment;

  const apiCallParams = {
    mutation: services.UPDATE_CASE_DATA_FORM,
    variables: { appointmentId, input: formData },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.mutate, apiCallParams)
    .then(({ data: { updateCaseDataForm: payload } }) => {
      return dispatch({
        type: UPDATE_CASE_DATA_FORM.success,
        payload,
      });
    })
    .catch((err) => {
      dispatch(errorAction(UPDATE_CASE_DATA_FORM.failure, err));
    });
};

export const clearCaseDataForm = () => ({
  type: CLEAR_CASE_DATA_FORM,
});
